import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const numberMask = createNumberMask({
  prefix: '',
  thousandsSeparatorSymbol: '',
  allowLeadingZeroes: true,
});

export function numberUnmask(val) {
  return (val.match(/\d+/g) || []).join('');
}

export function floatUnmask(val) {
  const numbers = val.match(/[\d.]+/g);
  return numbers ? numbers.join('') : 0;
}

export const currencyMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 10,
});

export const tdaCurrencyMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 5,
  minValue: 1000,
  maxValue: 43000,
});

export function removeSpace(str) {
  return str ? str.replace(/\s+/g, '') : '';
}

export const unmask = val => val.replace(/[$, ]+/g, '');

export function unmaskCurrency(val) {
  return val.replace(/[$, ]+/g, '');
}



// WEBPACK FOOTER //
// ./src/utils/masks.js